// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"64":"9448d00c","769":"3919dd5e"}[chunkId] + ".chunk.js";
};